<div class="notification" [class.notification--has-notifications]="hasUnseenNotifications$ | async" (click)="openNotificationsModal()">
    <ng-container *ngIf="unreadNotificationsCount$ | async as count">
        <div *ngIf="count > 0" class="notification__count">{{ count }}</div>
    </ng-container>
</div>
